(function () {
    const link = document.getElementById('price-view-final-link');
    const buttonWrapper = document.getElementById('price-view-final-button-wrapper');
    const priceContainer = document.getElementById('price-view-final-price-container');
    if (link && buttonWrapper && priceContainer) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            buttonWrapper.classList.add('hidden');
            priceContainer.classList.remove('hidden');
        });
    }
})();